<template>
  <div class="wrapper wrapper-full-page reset-page">
    <div class="content">
      <div class="container">
        <img class="login_logo" src="@/assets/logo_fernandez.png" />
        <div class="row">
          <div class="col-lg-4 col-md-6 ml-auto mr-auto">
            <form @submit.prevent="resetSendEmail">
              <div class="card">
                <div class="card-header">
                  <h3>Recuperar clave</h3>
                </div>
                <div class="card-content">
                  <fg-input
                    type="text"
                    label="Usuario / E-mail"
                    :disabled="false"
                    placeholder="Nombre de usuario / E-mail"
                    v-model="userdata.email"
                  />
                  <p-button type="primary" native-type="submit" :loading="isLoading">Enviar</p-button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <notifications />
  </div>
</template>

<script>
export default {
  name: 'RecoverKey',
  data() {
    return {
      userdata: {
        username: ''
      },
      isLoading: false
    };
  },
  methods: {
    resetSendEmail() {
      this.isLoading = true;
      this.$api.users.sendResetPasswordEmail(this.userdata).then(
        res => {
          this.$swal({
            title: 'Chequea tu e-mail!',
            text: 'Vas a recibir un mail con un link e instrucciones para terminar de recuperar tu clave.',
            type: 'success'
          });
          this.$router.push({ name: 'Login' });
        },
        res => {
          this.$notify({
            message: 'Usuario no encontrado.',
            icon: 'ti-gift',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'danger'
          });
          this.error = res.data;
          this.isLoading = false;
        }
      );
    }
  }
};
</script>

<style>
.reset-page {
  background-color: #f4f3ef !important;
}

.reset-page > .content {
  padding-top: 5vh;
}

.card .card-header {
  padding: 20px 15px 0;
  position: relative;
  border-radius: 3px 3px 0 0;
  z-index: 3;
}

.card .card-content {
  padding: 15px 15px 10px;
}

.card .card-footer {
  padding: 0 15px 15px;
}

.login_logo {
  display: block;
  width: 300px;
  margin: 0 auto;
}
</style>
